import { Component, OnInit } from '@angular/core';
import { LocationService } from 'app/masters/location-master/location.service';
import { MatTableDataSource } from '@angular/material/table';
import { billtypeModal } from 'app/masters/models/service-master.model';
import { FormControl } from '@angular/forms';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { AuthService } from 'app/auth/auth.service';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bill-type-master',
  templateUrl: './bill-type-master.component.html',
  styleUrls: ['./bill-type-master.component.scss']
})
export class BillTypeMasterComponent implements OnInit {
  destroybillType$: Subject<boolean> = new Subject<boolean>();
  dataSource = new MatTableDataSource<any>();
  holdbillData: any;
  billtypeData: billtypeModal = {}
  searchValue: string
  displayedColumns: string[] = ['billTypeName', 'serviceName', 'isActive'];
  serviceControl: FormControl;
  serviceActiveArray: any[] = [];
  filteredServiceArray: Observable<any[]>;

  constructor(public LocationService: LocationService, public branchmasterService: BranchMatserService, public authservice: AuthService) { }

  ngOnInit(): void {
    this.dataSource.filterPredicate = this.createFilter();
    this.GetBillingTypeMaster(0)
    this.getserviceData(0)
  }

  openbilltypeModal() {
    document.getElementById("billtypeModal").style.display = 'block';
    this.GetBillingTypeMaster(0)
  }
  closebilltypeModal() {
    document.getElementById("billtypeModal").style.display = 'none';
    this.searchValue = ''
    this.dataSource.filter = ''
  }
  openofferModal() {
    document.getElementById("offerModal").style.display = 'block';
  }
  closeofferModal() {
    document.getElementById("offerModal").style.display = 'none';
  }

  openserachofferModal() {
    document.getElementById("serachofferModal").style.display = 'block';
  }
  closeserachofferModal() {
    document.getElementById("serachofferModal").style.display = 'none';
  }

  getserviceData(id: number) {
    this.branchmasterService
      .getServicemaster(id, this.authservice.Loggeduser.specialityId).pipe(takeUntil(this.destroybillType$))
      .subscribe(
        (item: any[]) => {
          this.serviceActiveArray = item.filter((x: any) => x.isActive === true);
          this.initializeServiceControl();
        },
        (err) => {
          console.error('Error fetching service data:', err);
        }
      );
  }

  initializeServiceControl() {
    this.serviceControl = new FormControl();
    this.filteredServiceArray = this.serviceControl.valueChanges.pipe(
      startWith(''),
      map((service) =>
        service
          ? this.filterServiceFunction(service)
          : this.serviceActiveArray.slice()
      )
    );
  }

  filterServiceFunction(name: string): any[] {
    return this.serviceActiveArray.filter((service) =>
      service.serviceName.toLowerCase().includes(name.toLowerCase())
    );
  }

  GetBillingTypeMaster(id) {
    this.LocationService.GetBillingTypeMaster(id).pipe(takeUntil(this.destroybillType$)).subscribe((x: any) => {
      this.billtypeData = x;
      this.dataSource.data = x;
      this.holdbillData = x
    }, err => {
      if (err.status == 403) {
        this.LocationService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.LocationService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.LocationService.openSnackBar("API Failed", "OK");
      }
    });
  }

  applybilltypeFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.billTypeName?.toLowerCase().includes(transformedFilter) ||
        data.serviceName?.toLowerCase().includes(transformedFilter) ||
        (data.isActive ? 'active' : 'inactive').includes(transformedFilter)
      );
    };
  }

  savebilltypeMaster() {
    const selectedService = this.serviceActiveArray.find(
      (service) => service.serviceName.trim()  == this.billtypeData.serviceName.trim()
    );
  
    if (!selectedService) {
      this.LocationService.openSnackBar("Please select a valid Service", "OK");
      return;
    } 
    if (!this.billtypeData.pK_BillTypeId) {
      const existingBill = this.holdbillData.find(
        (bill) => bill.billTypeName.toLowerCase() === this.billtypeData.billTypeName?.toLowerCase());
      if (existingBill) {
        this.LocationService.openSnackBar('Already exists in the list', 'OK');
        this.clearForm();
        return;
      }
      const payload = {
        "BillingTypeMasterDto": {
          "PK_BillTypeId": this.billtypeData.pK_BillTypeId ? this.billtypeData.pK_BillTypeId : 0,
          "BillTypeName": this.billtypeData.billTypeName,
          "IsActive": this.billtypeData.isActive ? this.billtypeData.isActive : false,
          "FK_ServiceID": this.billtypeData.fK_ServiceID,
          "IsEdit": false
        }

      }
      this.LocationService.InsertBillingTypeMaster(payload).pipe(takeUntil(this.destroybillType$)).subscribe(
        (response: any) => {
          this.LocationService.openSnackBar('Record saved successfully', 'OK');
          this.clearForm();
          this.searchValue = ''
          this.GetBillingTypeMaster(0)
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    } else {
      const payload = {
        "BillingTypeMasterDto": {
          "PK_BillTypeId": this.billtypeData.pK_BillTypeId ? this.billtypeData.pK_BillTypeId : 0,
          "BillTypeName": this.billtypeData.billTypeName,
          "IsActive": this.billtypeData.isActive ? this.billtypeData.isActive : false,
          "FK_ServiceID": this.billtypeData.fK_ServiceID,
          "IsEdit": true
        }
      }
      this.LocationService.InsertBillingTypeMaster(payload).pipe(takeUntil(this.destroybillType$)).subscribe(
        (response: any) => {
          this.LocationService.openSnackBar('Record updated successfully', 'OK');
          this.clearForm();
          this.searchValue = ''
          this.GetBillingTypeMaster(0)
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    }
  }

  onServiceSelected(serviceId: any): void {
    const selectedService = this.serviceActiveArray.find(s => s.pK_ServiceId == serviceId);
    if (selectedService) {
      this.billtypeData.serviceName = selectedService.serviceName;
      this.billtypeData.fK_ServiceID = selectedService.pK_ServiceId;
    }
  }


  clearForm() {
    this.billtypeData = {
      pK_BillTypeId: 0,
      billTypeName: '',
      isActive: false,
      fK_ServiceID: null,
      serviceName: ''
    }
    this.getserviceData(0)
  }


  onRowDoubleClick(row) {
    this.billtypeData.billTypeName = row.billTypeName;
    this.billtypeData.isActive = row.isActive;
    this.billtypeData.fK_ServiceID = row.fK_ServiceID;
    this.billtypeData.pK_BillTypeId = row.pK_BillTypeId;
    this.billtypeData.serviceName = row.serviceName;
    this.closebilltypeModal()

  }

  onserviceChange(event: KeyboardEvent) {
    const serviceValue = (event.target as HTMLInputElement).value
    if (serviceValue == '') {
      this.billtypeData.fK_ServiceID = null;
    }
  }


  ngOnDestroy() {
    this.destroybillType$.next(true);
    this.destroybillType$.unsubscribe();
    this.searchValue = null;
    this.billtypeData = null;
    this.serviceActiveArray = null;
    this.holdbillData = null;
    this.filteredServiceArray = null;
  }
}
